import { useAuth } from '../contexts/AuthContext';
export default useAuth;
